import { render } from "./ApplicationModal.vue?vue&type=template&id=488fedee"
import script from "./ApplicationModal.vue?vue&type=script&lang=js"
export * from "./ApplicationModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__